import { StopGetDateTypeRequest } from '@trukt/tms-api/StopService';
import { createKey } from './createKey';

const keyHandler = createKey('stop');

export const StopServiceKeys = {
  key: keyHandler.key,
  getDateTypes: keyHandler.createMethod<StopGetDateTypeRequest>(),
};
